<div mat-dialog-content>
    <h1 class="title">Escolha um status para negociação</h1>
    <div class="row mt-3">
      <div class="col-12">
        <mat-form-field>
            <mat-select [(ngModel)]="statusSelected" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let status of statuses;" [value]="status">
                {{getStatus(status)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <div class="row mt-3 mx-auto">
        <div class="col-12">
          <button class="btn btn-primary btn-rounded btn-block" (click)="onClickConfirm()" [disabled]="!statusSelected"
            [ngClass]="{loading: !statusSelected}">
            <div class="btn-spinner float-left" *ngIf="!statusSelected"></div>
            <span>
              CONFIRMAR
            </span>
          </button>
        </div>
        <div class="col-12 mt-2 mb-2">
          <button class="btn btn-transparent btn-rounded btn-block"
            (click)="onNoClick()">CANCELAR</button>
        </div>
      </div>
    </div>
  </div>